module.exports = __webpack_public_path__ + "static/schoolLog.3ffc8af2.jpg";